import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Register = () => import('@/views/pages/Register');

// Users

Vue.use(Router);
Vue.use(VueCookie);

var route = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
})

function configRoutes () {
  var routes = [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'journal2/balance',
          name: 'Journal-Balance',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'purchase',
              name: 'BalancePurchase',
              component: () => import('../views/balance/Purchase.vue')
            },
            {
              path: 'debt-payment',
              name: 'DebtPayment',
              component: () => import('../views/balance/DebtPayment.vue')
            },
            {
              path: 'petty-cash',
              name: 'PettyCash-Balance',
              component: () => import('../views/balance/PettyCash.vue')
            },
            {
              path: 'purchase-assets',
              name: 'PurchaseAssets',
              component: () => import('../views/balance/PurchaseAsset.vue')
            },
            {
              path: 'dividen',
              name: 'Dividen',
              component: () => import('../views/balance/Dividen.vue')
            },
            {
              path: 'stock',
              name: 'BalanceStock',
              component: () => import('../views/balance/Stock.vue')
            },
          ]
        },
        {
          path: 'export',
          name: 'Export Excel',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: ':domain/:sub',
              name: 'ExportExcel',
              component: () => import('../views/export/Export.vue')
            }
          ]
        },
        {
          path: 'journal/income-statement',
          name: 'Journal-Income',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'sales',
              name: 'IS-Sales',
              component: () => import('../views/incomestatement/Sales.vue')
            },
            {
              path: 'payrol',
              name: 'Payrol',
              component: () => import('../views/incomestatement/Payrol.vue')
            },
            {
              path: 'office-rent',
              name: 'OfficeRent',
              component: () => import('../views/incomestatement/OfficeRent.vue')
            },
            {
              path: 'ops',
              name: 'Operation',
              component: () => import('../views/incomestatement/Ops.vue')
            },
            {
              path: 'hpp',
              name: 'HPP',
              component: () => import('../views/incomestatement/Hpp.vue')
            },
          ]
        },
        {
          path: 'journal/balance/purchase',
          name: 'Balance',
          component: () => import('../views/balance/Purchase.vue')
        },
        {
          path: 'journal',
          name: 'Jurnal',
          component: () => import('../views/balance/Jurnal.vue')
        },
        {
          path: 'income',
          name: 'Income',
          component: () => import('../views/incomestatement/Index.vue')
        },
        {
          path: 'report-master',
          name: 'Reports',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'items',
              name: 'RoportItem',
              component: () => import('../views/report/Item.vue')
            },
            {
              path: 'supplier',
              name: 'ReportSupplier',
              component: () => import('../views/report/Supplier.vue')
            },
            {
              path: 'customer',
              name: 'ReportCustomer',
              component: () => import('../views/report/Customer.vue')
            },
            {
              path: 'user',
              name: 'ReportUser',
              component: () => import('../views/report/User.vue')
            },
          ]
        },
        {
          path: 'report-trs',
          name: 'Info Transaction',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'po',
              name: 'RoportTransactionPo',
              component: () => import('../views/report/PO.vue')
            },
            {
              path: 'purchase',
              name: 'RoportTransactionPurchase',
              component: () => import('../views/report/Purchase.vue')
            },
            {
              path: 'sale',
              name: 'RoportTransactionSale',
              component: () => import('../views/report/Sale.vue')
            },
            {
              path: 'return-supplier',
              name: 'RoportTransactionReturSupplier',
              component: () => import('../views/report/ReturnToSupplier.vue')
            },
            {
              path: 'return-customer',
              name: 'RoportTransactionReturCustomer',
              component: () => import('../views/report/ReturnToCustomer.vue')
            },
            {
              path: 'warranty',
              name: 'RoportTransactionWarranty',
              component: () => import('../views/report/Warranty.vue')
            },
          ]
        },
        {
          path: 'report-accounting',
          name: 'Info Accounting',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'hutang',
              name: 'ReportAccDebt',
              component: () => import('../views/report/Debt.vue')
            },
            {
              path: 'piutang',
              name: 'ReportAccReceivable',
              component: () => import('../views/report/Receivable.vue')
            },
          ]
        },
        {
          path: 'report-account',
          name: 'Info Account',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'coa',
              name: 'ReportAccCOA',
              component: () => import('../views/report/COA.vue')
            },
            {
              path: 'piutang',
              name: 'ReportAccReceivable',
              component: () => import('../views/report/Receivable.vue')
            },
          ]
        },
        {
          path: 'about',
          name: 'About',
          component: () => import('../views/about/Index.vue')
        },
        {
          path: 'master',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'item',
              meta: {
                label: 'Product'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'ProductList',
                  component: () => import('../views/item/ItemList.vue')
                },
                {
                  path: 'add',
                  name: 'AddItem',
                  component: () => import('../views/item/ItemAdd.vue')
                },
              ]
            },
            {
              path: 'supplier',
              meta: {
                label: 'Supplier'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'SupplierList',
                  component: () => import('../views/supplier/Index')
                },
                {
                  path: 'add',
                  name: 'SupplierAdd',
                  component: () => import('../views/supplier/Add')
                }
              ],
            },
            {
              path: 'customer',
              meta: {
                label: 'Customer'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'CustomerList',
                  component: () => import('../views/customer/Index')
                },
                {
                  path: 'add',
                  name: 'CustomerAdd',
                  component: () => import('../views/customer/Add')
                }
              ]
            },
            {
              path: 'customer-type',
              meta: {
                label: 'Customer'
              },
              component: {
                render (c) {
                  return c('router-view');
                }
              },
              children: [
                {
                  path: '',
                  name: 'CustomerTypes',
                  component: () => import('../views/customer/CustomerTypes')
                },
                {
                  path: 'add',
                  name: 'CustomerType',
                  component: () => import('../views/customer/CustomerType')
                },
              ]
            },
            {
              path: 'Unit',
              meta: {
                label: 'Unit'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'UnitList',
                  component: () => import('../views/unit/Index')
                },
                {
                  path: 'add',
                  name: 'UnitAdd',
                  component: () => import('../views/unit/Add')
                }
              ]
            },
            {
              path: 'salary-item',
              meta: {
                label: 'SalaryItem'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'SalaryItemList',
                  component: () => import('../views/salaryitem/Index')
                },
                {
                  path: 'add',
                  name: 'SalaryItemAdd',
                  component: () => import('../views/salaryitem/Add')
                }
              ]
            },
            {
              path: 'payment-method',
              meta: {
                label: 'PaymentMethod'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'UnitList',
                  component: () => import('../views/paymentmethod/Index')
                },
                {
                  path: 'add',
                  name: 'UnitAdd',
                  component: () => import('../views/paymentmethod/Add')
                }
              ]
            },
            {
              path: 'user',
              meta: {
                label: 'User'
              },
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'UserList',
                  component: () => import('../views/user/Index')
                },
                {
                  path: 'add',
                  name: 'AddList',
                  component: () => import('../views/user/Add')
                },
              ]
            },
          ]
        },
        {
          path: 'product',
          meta: {
            label: 'Product'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'stock',
              name: 'Stocks',
              component: () => import('../views/product/Stock.vue')
            },
            {
              path: 'stock/:id',
              name: 'Stocks',
              component: () => import('../views/product/StockDetail.vue')
            },
            {
              path: 'stock-opname',
              name: 'Stock-opname',
              component: () => import('../views/product/StockOpname.vue')
            },
            {
              path: 'stock-opname-warranty',
              name: 'Stock-opname-warranty',
              component: () => import('../views/product/StockOpnameWarranty.vue')
            },
            {
              path: 'barcode',
              name: 'Barcode',
              component: () => import('../views/product/Barcode.vue')
            },
            {
              path: 'warranty',
              name: 'Warranty',
              component: () => import('../views/product/Warranty.vue')
            },
            {
              path: 'warranty/:code',
              name: 'WarrantyDetail',
              component: () => import('../views/product/WarrantyDetail.vue')
            },
          ]
        },
        {
          path: 'return',
          meta: {
            label: 'Return'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'sales',
              name: 'Sales',
              component: () => import('../views/return/Pembelian.vue')
            },
            {
              path: 'info-sales',
              name: 'Info-Sales',
              component: () => import('../views/return/PembelianInfo.vue')
            },
            {
              path: 'sales-edit',
              name: 'Edit-Return-Sales',
              component: () => import('../views/return/ReturnPembelianEdit.vue')
            },
            {
              path: 'purchase',
              name: 'Penjualan',
              component: () => import('../views/return/Penjualan.vue')
            }
          ]
        },
        {
          path: 'po',
          meta: {
            label: 'PO'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'PoCreate',
              meta: {
                label: 'Create'
              },
              component: () => import('../views/po/Create.vue')
            },
            {
              path: 'process',
              name: 'PoProcess',
              meta: {
                label: 'Process'
              },
              component: () => import('../views/po/Process.vue')
            },
            {
              path: 'success',
              name: 'PoSuccess',
              meta: {
                label: 'Success'
              },
              component: () => import('../views/po/Success.vue')
            },
            {
              path: 'intransit',
              name: 'Intransit',
              meta: {
                label: 'Intransit'
              },
              component: () => import('../views/po/Intransit.vue')
            },
            {
              path: 'preview/:id',
              name: 'PoFaktur',
              meta: {
                label: 'Preview'
              },
              component: () => import('../views/po/PreviewPo.vue')
            },
          ]
        },
        {
          path: 'kasir',
          meta: {
            label: 'Kasir'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'KasirCreate',
              component: () => import('../views/kasir/Index.vue')
            },
            {
              path: 'v2',
              name: 'KasirCreate2',
              component: () => import('../views/kasir/IndexV2.vue')
            },
            {
              path: 'process',
              name: 'KasirProcess',
              component: () => import('../views/kasir/Process.vue')
            },
            {
              path: 'success',
              name: 'KasirSuccess',
              component: () => import('../views/kasir/Success.vue')
            },
            {
              path: 'deleted',
              name: 'KasirDeleted',
              component: () => import('../views/kasir/Deleted.vue')
            },
            {
              path: 'compare/:id',
              name: 'KasirCompare',
              component: () => import('../views/kasir/ProcessCompare.vue')
            },
          ]
        },
        {
          path: '/print-preview',
          name: 'PrintPreview',
          component: () => import('../views/print/Preview.vue'),
          children: [
            {
              path: 'kasir/faktur/:id',
              name: 'KasirFaktur-Prev',
              component: () => import('../views/print/Kasir.vue')
            },]
        },
        {
          path: '/account',
          meta: {
            label: 'Account'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'bank',
              name: 'Bank',
              component: () => import('../views/account/Bank.vue')
            },
            {
              path: 'coa',
              name: 'Chart of Account',
              component: () => import('../views/account/ChartOfAccounts.vue')
            },
            {
              path: 'coa/add',
              name: 'Chart of Account',
              component: () => import('../views/account/ChartOfAccount.vue')
            },
          ]
        },
        {
          path: '/j',
          meta: {
            label: 'Pencatatan'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'index',
              name: 'Index',
              component: () => import('../views/debt/Index.vue')
            },
            {
              path: 'debt/:id',
              name: 'Index',
              component: () => import('../views/debt/DebtEdit.vue')
            },
            {
              path: 'receivable',
              name: 'Receivable',
              component: () => import('../views/debt/Receivable.vue')
            },
            {
              path: 'receivable/:id',
              name: 'ReceivableEdit',
              component: () => import('../views/debt/ReceivableEdit.vue')
            },
            {
              path: 'petty-cash',
              name: 'PettyCash-Journal',
              component: () => import('../views/pettycash/Add.vue')
            },
            {
              path: 'mutasi-bank',
              name: 'MutasiBank',
              component: () => import('../views/bankhistory/Add.vue')
            },
            {
              path: 'asset',
              name: 'Journal-Asset',
              component: () => import('../views/asset/Index.vue')
            },
            {
              path: 'installation-history',
              name: 'InstalationHistory',
              component: () => import('../views/installationhistory/Add.vue')
            },
          ]
        },
        {
          path: '/logbook',
          meta: {
            label: 'LogBook'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'petty-cash',
              name: 'PettyCash-LogBook',
              meta: {
                label: 'Petty Cash'
              },
              component: () => import('../views/logbook/PettyCash.vue')
            },
            {
              path: 'assets',
              name: 'Asset',
              component: () => import('../views/logbook/Asset.vue')
            },
            {
              path: 'mutasi',
              name: 'BankHistory',
              meta: {
                label: 'Mutasi Bank'
              },
              component: () => import('../views/logbook/BankHistory.vue')
            },
            {
              path: 'installation-service',
              name: 'UangPemasangan',
              meta: {
                label: 'Uang Pemasangan'
              },
              component: () => import('../views/logbook/InstallationService.vue')
            },
            {
              path: 'intransit-goods',
              name: 'IntransitGoods',
              meta: {
                label: 'Barang Intransit'
              },
              component: () => import('../views/logbook/IntransitGoods.vue')
            },
          ]
        },
      ],
    },
    {
      path: '/print',
      name: 'LoginPage',
      component: () => import('../views/print/Index.vue'),
      children: [
        {
          path: 'po/:id',
          name: 'POPrint',
          meta: {
            label: 'Print'
          },
          component: () => import('../views/po/PrintPo.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: Login,
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
    {
      path: '/print',
      name: 'Print',
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'kasir/faktur/:id',
          name: 'KasirFaktur-Print',
          component: () => import('../views/print/Kasir.vue')
        },
        {
          path: 'po/faktur/:id',
          name: 'PoFaktur-Print',
          component: () => import('../views/print/Po.vue')
        },
        {
          path: 'journal/income-statement/sales',
          name: 'PoFaktur-Print',
          component: () => import('../views/print/ICSales.vue')
        },
      ]
    }
  ]
  return routes;
}

route.beforeEach((to, from, next) => {
  const authObj = getAuth()
  const now = Math.round((new Date()).getTime() / 1000);
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (authObj == null || parseInt(authObj.expired_at) < now) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});


function getAuth () {
  const auth = Vue.cookie.get("larapos")
  const authObj = JSON.parse(auth)
  return authObj
}

export default route;